import { render, staticRenderFns } from "./RepseDocumentation.vue?vue&type=template&id=4d3fcb7c"
import script from "./RepseDocumentation.vue?vue&type=script&lang=js"
export * from "./RepseDocumentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports